<script setup lang="ts">
interface Props {
    route: string;
    title: string;
}
defineProps<Props>();
</script>

<template>
    <li class="cursor-pointer whitespace-nowrap text-truncate hover:bg-gray-400">
        <router-link
            :to="route"
            class="block px-4 py-2"
        >
            <slot />
            <span class="ml-4">{{ title }}</span>
        </router-link>
    </li>
</template>
